module.exports = __webpack_public_path__ + "Flag-850.e225d3179867f9f277f630cc16059594.svg";